module.exports = __webpack_public_path__ + "static/media/img.cee4365c.jpg";